import React from 'react';

function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg 
      width="16" 
      height="17" 
      viewBox="0 0 16 17" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M14 14.4972L11.1 11.5972M12.6667 7.83056C12.6667 10.7761 10.2789 13.1639 7.33333 13.1639C4.38781 13.1639 2 10.7761 2 7.83056C2 4.88504 4.38781 2.49722 7.33333 2.49722C10.2789 2.49722 12.6667 4.88504 12.6667 7.83056Z" stroke="#1E1E1E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default SearchIcon;
